import {Component} from '@angular/core';

@Component({
    selector: 'app-access-denied',
    template: `<br>
    <h1 class="text-center mt-5">ACCESS DENIED.</h1>
    <h2 class="text-center">You DO NOT have privileges to access this page.</h2>`
})
export class AccessDeniedComponent {

}
